import { extendTailwindMerge } from "tailwind-merge";

export const tw = extendTailwindMerge({
  extend: {
    theme: {
      // ↓ `text` is the key of the namespace `--text-*`
      text: [
        "label-sm",
        "label-md",
        "label-lg",
        "label-xl",
        "body-sm",
        "body-md",
        "body-lg",
        "heading-xs",
        "heading-sm",
        "heading-md",
        "heading-lg",
        "heading-xl",
      ],
      color: [
        "fill-primary",
        "fill-primary-hover",
        "fill-primary-active",

        "fill-brand",
        "fill-brand-hover",
        "fill-brand-active",
        "fill-brand-selected",

        "fill-solid",
        "fill-solid-hover",
        "fill-solid-active",

        "fill-selected",

        "fill-default",

        "surface",
        "surface-hover",
        "surface-active",

        "surface-secondary",
        "surface-secondary-hover",
        "surface-secondary-active",

        "surface-informative",
        "surface-success",
        "surface-caution",
        "surface-error",

        "border",
        "border-hover",
        "border-active",
        "border-selected",
        "border-secondary",

        "border-brand",
        "border-brand-hover",
        "border-brand-active",
        "border-brand-selected",

        "ring",

        /* Icon Colors */
        "icon-primary",
        "icon-primary-hover",
        "icon-primary-active",
        "icon-on-bg-fill",
        "icon-secondary",
        "icon-secondary-hover",
        "icon-secondary-active",
        "icon-error",
        "icon-informative",
        "icon-caution",
        "icon-brand",

        /* Text Colors */
        "text-success",
        "text-on-bg-fill",
        "text-primary",
        "text-primary-hover",
        "text-primary-active",
        "text-secondary",
        "text-tertiary",
        "text-error",
        "text-primary-active",
        "text-brand",

        /* Input Colors */
        "input-surface-fill",
        "input-surface-hover",
        "input-surface-active",
        "input-border",
        "input-border-focus",
        "input-border-hover",
        "input-border-active",
        "input-border-error",

        /* Blanket Colors */
        "blanket-bg",

        /* Transport Colors */
        "transport-plane",

        /* Popup Colors */
        "tooltip-bg",
      ],
    },
  },
});
